var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "account-subscribes" },
    [
      _c("h2", [_vm._v("Настройка уведомлений")]),
      _c(
        "div",
        { staticClass: "settings" },
        _vm._l(_vm.currentSettings, function(subscription) {
          return _c("ui-checkbox", {
            key: subscription.id,
            staticClass: "checkbox",
            attrs: {
              headline: _vm.labels[subscription.code] || "",
              label: subscription.description
            },
            model: {
              value: subscription.active,
              callback: function($$v) {
                _vm.$set(subscription, "active", $$v)
              },
              expression: "subscription.active"
            }
          })
        }),
        1
      ),
      _c("ui-button", {
        staticClass: "button",
        attrs: {
          wide: "",
          disabled: _vm.settingsIdentical,
          loading: _vm.isLoading,
          text: "Сохранить"
        },
        on: { click: _vm.save }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }